import DataTable from "react-data-table-component";
import React, { useEffect } from "react";
import { Col, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import SpinnerComponent from "../../../../components/spinner/spinner";
import {
  setReportLimit,
  setReportPage,
} from "../../../../redux/actions/reports/reportsAction";
import { history } from "../../../../app/AppRouter";
import { conditionalRowStyles,addExtraColumnPerGymSettings } from "./utils";

export const ReportsTable = ({ columns,clickedRow,withExtraCols }) => {
  const { reports, reportsCount } = useSelector((state) => state.report);
  const { commonLoading } = useSelector((state) => state.common);
  const [reportColumns, setReportColumns] = React.useState(columns);
  const {gym, gymConfig} = useSelector((state) => state.gym);
  const memberCreditEnabled = Boolean(
    gymConfig?.manageMemberships?.memberCredit?.enabled
  );
  const visibleReports = React.useMemo(
    () =>
      memberCreditEnabled || !Array.isArray(reports)
        ? reports
        : reports.filter((row) => row?.category !== "memberCredit"),
    [memberCreditEnabled, reports]
  );
  const dispatch = useDispatch();
  useEffect(()=>{
    if(withExtraCols){
      const settings =gym?.settings
      const {extraFieldsForTable}=addExtraColumnPerGymSettings({settings})
      setReportColumns([...columns,...extraFieldsForTable])
    }
    else setReportColumns(columns)

  }, [withExtraCols, gym, columns]);
  return (
    <Row>
      <Col xs={12} className="mt-4">
        {reports && (
          <DataTable
            className="dark-blue-table"
            columns={reportColumns}
            data={visibleReports}
            conditionalRowStyles={conditionalRowStyles}
            progressPending={commonLoading}
            progressComponent={
              <div className="d-flex flex-column align-items-center justify-content-center py-5">
                <SpinnerComponent />
                <h5 className="mt-3 mb-0">Loading report...</h5>
              </div>
            }
            pagination
            paginationServer
            paginationTotalRows={reportsCount}
            onChangeRowsPerPage={(newLimit) =>
              dispatch(setReportLimit(newLimit))
            }
            onChangePage={(newPage) => dispatch(setReportPage(newPage))}
            onRowClicked={(row)=>{
              if(clickedRow){
                history.push(`/gym-panel/membersinfo/${row?.memberId}`);

              }
              }}
               // Add this line to handle row clicks

          />
        )}
        
      </Col>
    </Row>
  );
};
